import styles from "../../../../styles/components/Modal/Employees/components/PersonalData.module.css";
import React, { useCallback, useContext } from 'react';
import { InputSelector } from "../../../UI/InputSelector";
import { InputPasswordSelector } from "../../../UI/InputPasswordSelector";
import { personalDataFieldsConfig } from "../../../../utils/api/Admin/personalDataFieldsConfig";
import { LangContext } from '../../../../context/LangContext';
import { ThemeContext } from '../../../../context/ThemeContext';

const translations = {
    ru: {
        labels: {
            first_name: "Имя",
            last_name: "Фамилия",
            email: "Email",
            telegram_tag: "Telegram",
            telephony_extension: "Телефония",
            password: "Пароль",
            desk_id: "Деск",
            role: "Роль",
        }
    },
    en: {
        labels: {
            first_name: "First Name",
            last_name: "Last Name",
            email: "Email",
            telegram_tag: "Telegram",
            telephony_extension: "Telephony",
            password: "Password",
            desk_id: "Desk",
            role: "Role",
        }
    },
};

export const PersonalData = ({
    validationErrors,
    userInfo,
    setUserInfo,
    roleOptions,
    deskOptions,
    onRoleChange,
    onDeskChange,
    setValidationErrors,
    isNewUser,
    selectedDeskIds,
    MultiSelectComponent,
    DropdownComponent,
    isDark,
    showTelephonyExtension = false,
}) => {
    const { langSelected } = useContext(LangContext);
    const t = translations[langSelected] || translations.ru;

    const handleInputChange = useCallback((filterName, value) => {
        setUserInfo({ [filterName]: value });
    }, [setUserInfo]);

    const handleRoleSelect = useCallback((name, value) => {
        onRoleChange(value);
    }, [onRoleChange]);

    const handleDeskSelect = useCallback((name, value, key) => {
        onDeskChange(name, value, key);
    }, [onDeskChange]);

    const handleFocus = useCallback((name) => {
        setValidationErrors(prev => {
            const newErrors = { ...prev };
            if (newErrors[name]) {
                delete newErrors[name];
            }
            return newErrors;
        });
    }, [setValidationErrors]);

    const handleBlur = useCallback((name) => {

    }, []);

    const fieldsToShow = personalDataFieldsConfig;

    const RoleDropdown = DropdownComponent;
    const DeskMultiSelect = MultiSelectComponent;

    const renderInputField = (field) => {
        const commonProps = {
            filterName: field.key,
            selectedValue: userInfo[field.key] || '',
            handleFilterChange: handleInputChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            hasError: !!validationErrors[field.key],
            errorMessage: validationErrors[field.key],
            isDark: isDark,
            placeholder: field.placeholder,
        };

        if (field.key === 'password') {
            return (
                <InputPasswordSelector
                    {...commonProps}
                    required={isNewUser}
                />
            );
        }

        return (
            <InputSelector
                {...commonProps}
                type={field.key === 'email' ? 'email' : 'text'}
                readOnly={field.key === 'id'}
            />
        );
    };

    return (
        <div className={styles.modalContent}>
            <div className={styles.section}>
                {fieldsToShow.map((field) => (
                    <div key={field.key} className={styles.inputRow}>
                        <label htmlFor={field.key} className={`${isDark ? styles.darkLabel : ''}`}>{t.labels[field.key]}:</label>

                        {field.type === "input" ? (
                            renderInputField(field)
                        ) : field.type === "dropdown" && field.key === "role" ? (
                            <RoleDropdown
                                filterName={field.key}
                                selectedValue={userInfo.role}
                                handleFilterChange={handleRoleSelect}
                                options={roleOptions}
                                hasError={!!validationErrors[field.key]}
                                errorMessage={validationErrors[field.key]}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                isDark={isDark}
                            />
                        ) : field.type === "dropdown" && field.key === "desk_id" ? (
                            <DeskMultiSelect
                                filterName={field.key}
                                filterKey="desk_ids"
                                selectedValue={selectedDeskIds || []}
                                handleFilterChange={handleDeskSelect}
                                options={deskOptions}
                                hasError={!!validationErrors['desk_ids']}
                                errorMessage={validationErrors['desk_ids']}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                isDark={isDark}
                            />
                        ) : null}
                    </div>
                ))}

                {showTelephonyExtension && (
                    <div className={styles.inputRow}>
                        <label htmlFor="telephony_extension" className={`${isDark ? styles.darkLabel : ''}`}>{t.labels.telephony_extension}:</label>
                        <InputSelector
                            filterName="telephony_extension"
                            selectedValue={userInfo.telephony_extension || ''}
                            handleFilterChange={handleInputChange}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            hasError={!!validationErrors.telephony_extension}
                            errorMessage={validationErrors.telephony_extension}
                            isDark={isDark}
                            placeholder="ph1111x001"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
